import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.spinnerBackgroundStyle, attrs: { id: "spinner" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-center justify-center full-width full-height",
        },
        [
          _c(VProgressCircular, {
            attrs: { color: "blue", indeterminate: "", size: "25" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.loginWithFacebook.apply(null, arguments)
            },
          },
        },
        [
          _c("div", {
            staticClass: "fb-login-button",
            staticStyle: { "pointer-events": "none" },
            attrs: {
              "data-max-rows": _vm.maxRows,
              "data-size": _vm.size,
              "data-button-type": _vm.buttonType,
              "data-use-continue-as": _vm.useContinueAs,
              "data-width": _vm.dataWidth,
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }